import { Product } from './products'

/**
 * YarboCare Extended Warranty / Product Protection — MOCKUP DATA
 *
 * Developer handoff note:
 * Final eligibility, pricing, and checkout behavior should be wired
 * dynamically. YarboCare should appear only for eligible complete systems
 * and bundles unless final dealer warranty rules confirm additional
 * product eligibility. Plan pricing below is placeholder for design only —
 * pull from final warranty product/SKU rules, not hard-coded into UI.
 */

export type YarboCarePlanId = 'ew-3yr' | 'ad-1yr-ew-3yr' | 'ad-3yr-ew-3yr'

export interface YarboCarePlan {
  id: YarboCarePlanId
  title: string
  badge: string
  /** Placeholder price — replace with dynamic value from warranty provider */
  priceMockup: number
  bullets: string[]
  highlight?: boolean
}

export const YARBOCARE_PLANS: YarboCarePlan[] = [
  {
    id: 'ew-3yr',
    title: '3-Year Extended Warranty',
    badge: 'Extended Coverage',
    priceMockup: 299,
    bullets: [
      'Adds 3 more years after the standard warranty',
      'Helps cover manufacturing defects and performance failures',
      'Up to 5 years total warranty coverage on eligible systems',
    ],
  },
  {
    id: 'ad-1yr-ew-3yr',
    title: '1-Year Accidental Damage + 3-Year Extended Warranty',
    badge: 'Added Accident Protection',
    priceMockup: 449,
    bullets: [
      'Includes 3-year extended warranty coverage',
      'Adds 1 year of accidental damage protection',
      'Helps cover eligible drops, collisions, and impact damage during normal use',
    ],
  },
  {
    id: 'ad-3yr-ew-3yr',
    title: '3-Year Accidental Damage + 3-Year Extended Warranty',
    badge: 'Most Coverage',
    priceMockup: 649,
    bullets: [
      'Includes 3-year extended warranty coverage',
      'Adds 3 years of accidental damage protection',
      'Best option for customers who want the most coverage available',
    ],
    highlight: true,
  },
]

/**
 * Eligibility rule:
 * Uses the eligibleForYarboCare flag from the product data.
 */
export function isEligibleForYarboCare(product: Product): boolean {
  return !!product.eligibleForYarboCare
}

export function getPlanById(
  id: YarboCarePlanId | null | undefined,
): YarboCarePlan | undefined {
  if (!id) return undefined
  return YARBOCARE_PLANS.find((p) => p.id === id)
}

export const YARBOCARE_DISCLAIMER =
  'Coverage, eligibility, and pricing vary by product and plan. Accessories and standalone modules may not qualify. Final terms are provided by YarboCare / XCotton.'

export const YARBOCARE_PROVIDER_NOTE =
  'YarboCare coverage is provided through XCotton and underwritten by AIG.'
